var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5389 26.2619C30.1439 27.1703 29.6764 28.0064 29.1347 28.7752C28.3963 29.8231 27.7917 30.5486 27.3258 30.9514C26.6035 31.6126 25.8297 31.9512 25.001 31.9705C24.4061 31.9705 23.6887 31.802 22.8536 31.4601C22.0157 31.1199 21.2457 30.9514 20.5417 30.9514C19.8033 30.9514 19.0114 31.1199 18.1644 31.4601C17.316 31.802 16.6326 31.9801 16.1101 31.9978C15.3154 32.0315 14.5234 31.6832 13.7328 30.9514C13.2281 30.5132 12.597 29.7622 11.8408 28.6981C11.0296 27.5619 10.3626 26.2442 9.84011 24.7421C9.28052 23.1195 9 21.5483 9 20.0272C9 18.2848 9.37822 16.782 10.1358 15.5226C10.7312 14.5111 11.5232 13.7131 12.5146 13.1273C13.5059 12.5415 14.5771 12.243 15.7306 12.2239C16.3618 12.2239 17.1895 12.4183 18.218 12.8002C19.2437 13.1835 19.9023 13.3778 20.191 13.3778C20.4069 13.3778 21.1385 13.1506 22.3788 12.6975C23.5517 12.2774 24.5416 12.1034 25.3525 12.1719C27.5499 12.3485 29.2008 13.2108 30.2987 14.7643C28.3334 15.9497 27.3613 17.6099 27.3806 19.7398C27.3984 21.3988 28.0029 22.7793 29.1911 23.8754C29.7296 24.3842 30.3309 24.7774 31 25.0566C30.8549 25.4755 30.7017 25.8767 30.5389 26.2619ZM25.4992 6.52015C25.4992 7.82044 25.022 9.03453 24.0708 10.1583C22.9229 11.4942 21.5345 12.2661 20.0289 12.1443C20.0097 11.9883 19.9985 11.8241 19.9985 11.6516C19.9985 10.4033 20.5444 9.06743 21.5139 7.97514C21.9978 7.4221 22.6134 6.96225 23.3598 6.59542C24.1046 6.23406 24.8092 6.03422 25.4718 6C25.4911 6.17383 25.4992 6.34767 25.4992 6.52013V6.52015Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/Apple.274b80c0cd1f021bf772d398ef0581eb.svg";
export { ForwardRef as ReactComponent };